module.exports = __webpack_public_path__ + "cg.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/cg.svg
// module id = 740
// module chunks = 0